import { isMobile } from "../common";
import Dropdown from "./Dropdown";

export function FilterTab({
  options,
  selected,
  onClick,
  isSecondary,
  onResultOptions,
  isRounded,
  isSingle,
  isSmall,
  disabledOptions = [],
}: {
  options: string[];
  selected: string[];
  isSecondary?: boolean;
  isRounded?: boolean;
  isSmall?: boolean;
  isSingle?: boolean;
  onClick?: (option: string, index: number) => void;
  onResultOptions?: (options: string[]) => void;
  disabledOptions?: string[];
}) {
  const handleSelection = (option: string, index: number) => {
    // Check if the option is disabled
    if (disabledOptions.includes(option)) {
      return; // Do nothing if option is disabled
    }

    if (onClick) {
      onClick(option, index);
    }
    if (onResultOptions) {
      if (selected.includes(option)) {
        if (selected.length === 1) {
          onResultOptions(options); // Reset to all options if only one is selected
        } else {
          onResultOptions(selected.filter((item) => item !== option)); // Remove the selected option
        }
      } else {
        onResultOptions([...selected, option]); // Add new option to selection
      }
    }
  };

  return isSingle && isMobile ? (
    <Dropdown
      options={options}
      selected={selected[0]}
      onSelect={(option: string, index: number) => {
        handleSelection(option, index); // Use the same logic here
      }}
    />
  ) : (
    <div id="trader-tab" className="flex">
      {options.map((option, index) => {
        const isDisabled = disabledOptions.includes(option);

        return (
          <button
            key={option}
            onClick={() => handleSelection(option, index)} // Reuse handleSelection here as well
            disabled={isDisabled}
            className={
            (isSmall ? "tab-small " : "tab ") +
              (isRounded ? "tab-rounded " : "") +
              (selected.includes(option) && options.length !== selected.length
                ? "tab-active"
                : "") +
              (index === 0
                ? " tab-left "
                : index === options.length - 1
                ? " tab-right "
                : "") +
              (selected.includes(option) &&
              isSecondary &&
              options.length !== selected.length
                ? " tab-secondary"
                : "") +
              (isDisabled
                ? " opacity-50 cursor-not-allowed bg-gray-100"
                : " cursor-pointer")
            }
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}

export function getResultFilterOptions(
  options: string[],
  currentlySelected: string[],
  selected: string
): string[] {
  if (currentlySelected.includes(selected)) {
    if (currentlySelected.length === options.length) {
      return [selected];
    }
    if (currentlySelected.length === 1) {
      return options;
    } else {
      return currentlySelected.filter((item) => item !== selected);
    }
  } else {
    return [...currentlySelected, selected];
  }
}
